// import React, { useEffect, useState } from "react";
// import Admin from "../Dashboard";
// import {
//   Box,
//   Button,
//   Divider,
//   Stack,
//   TextField,
//   Typography,
// } from "@mui/material";
// import { Description } from "@mui/icons-material";

// import ReactQuill from "react-quill";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const AdminPolicyNotice = () => {
//   const [termsData, setTermsData] = useState([
//     {
//       title: "",
//       description: "",
//     },
//   ]);
//   const [termsError, setTermsError] = useState({
//     title: "",
//     description: "",
//   });
//   const navigate = useNavigate();
//   const toolbarOptions = [
//     ["bold", "italic", "underline", "link"],
//     [{ list: "ordered" }, { list: "bullet" }],
//     [{ align: [] }],
//     [{ script: "sub" }, { script: "super" }],
//     [{ color: [] }, { background: [] }],
//   ];
//   const module = { toolbar: toolbarOptions };
//   const handleAdd = () => {
//     setTermsData([...termsData, { title: "", description: "" }]);
//   };
//   const handleDelete = (index) => {
//     if (index == 0) {
//       return;
//     }
//     const deletedData = termsData.filter((_, i) => i !== index);
//     setTermsData(deletedData);
//   };
//   const handleDescriptionChange = (index, e) => {
//     const updatedData = [...termsData];
//     updatedData[index].description = e;
//     setTermsData(updatedData);
//   };
//   const handleChange = (index, e) => {
//     const updatedData = [...termsData];
//     updatedData[index].title = e.target.value;
//     setTermsData(updatedData);
//   };
//   const getPolicy = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}getPolicy`
//       );

//       if (response.status === 200) {
//         if (response.data.length > 0) {
//           const terms = response?.data?.map((terms) => {
//             return {
//               title: terms?.title || "",
//               description: terms?.description || "",
//             };
//           });
//           console.log("Policy fetched successfully", terms);
//           if (terms && terms.length > 0) {
//             setTermsData(terms);
//             return;
//           }
//         }
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     getPolicy();
//   }, []);

//   const validateFields = () => {
//     let isValid = true;

//     const errors = termsData.map(() => ({
//       title: "",
//       description: "",
//     }));

//     termsData.forEach((term, index) => {
//       // Validate title (same as before)
//       if (!term?.title || !term.title.trim()) {
//         errors[index].title = "Title is required.";
//         isValid = false;
//       }

//       // Check for description content in ReactQuill
//       const descriptionText = term?.description?.replace(/<[^>]+>/g, "").trim(); // Extract plain text by stripping HTML tags

//       if (!descriptionText) {
//         errors[index].description = "Description is required.";
//         isValid = false;
//       }
//     });

//     setTermsError(errors);
//     return isValid;
//   };

//   const addTerms = async () => {
//     if (!validateFields()) {
//       return;

//       // Proceed with submission logic
//     }
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}addPolicy`,
//         { policy: termsData }
//       );
//       if (response.status === 201) {
//         navigate("/admin/carousel");
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };
//   return (
//     <Stack gap="20px">
//       <Typography
//         sx={{
//           textAlign: "center",
//           width: "fit-content",
//           fontSize: { xs: 18, sm: 20 },

//           fontWeight: 700,
//           mb: 1,
//         }}
//       >
//         Policy Notice :
//       </Typography>
//       {termsData.map((item, index) => (
//         <Stack
//           gap="20px"
//           sx={{ border: "1px solid #ccc", borderRadius: "5px" }}
//           py="20px"
//           px="20px"
//         >
//           <Box>
//             <Typography
//               sx={{
//                 textAlign: "center",
//                 width: "fit-content",
//                 fontSize: { xs: 18, sm: 20 },

//                 fontWeight: 700,
//                 mb: 1,
//               }}
//             >
//               Title
//             </Typography>
//             <TextField
//               name="title"
//               value={item?.title}
//               onChange={(e) => handleChange(index, e)}
//               variant="outlined"
//               sx={{ width: "100%" }}
//             />{" "}
//             {termsError[index]?.title && (
//               <p style={{ color: "red" }}>{termsError[index].title}</p>
//             )}
//           </Box>
//           <Box>
//             <Typography
//               sx={{
//                 textAlign: "center",
//                 width: "fit-content",
//                 fontSize: { xs: 18, sm: 18 },

//                 fontWeight: 700,
//                 mb: 2,
//               }}
//             >
//               Description
//             </Typography>
//             <ReactQuill
//               value={item?.description}
//               name="description"
//               onChange={(e) => {
//                 handleDescriptionChange(index, e);
//               }}
//               modules={module}
//               theme="snow"
//               placeholder=""
//             />
//             {termsError[index]?.description && (
//               <p style={{ color: "red" }}>{termsError[index].description}</p>
//             )}
//           </Box>
//           {index > 0 && (
//             <Box
//               width="100%"
//               sx={{ display: "flex", justifyContent: "flex-start" }}
//             >
//               <Button
//                 sx={{
//                   background: "red",
//                 }}
//                 variant="contained"
//                 onClick={() => {
//                   handleDelete(index);
//                 }}
//               >
//                 Delete
//               </Button>
//             </Box>
//           )}
//         </Stack>
//       ))}
//       <Box width="100%" sx={{ display: "flex", justifyContent: "flex-end" }}>
//         <Button variant="contained" onClick={handleAdd}>
//           Add
//         </Button>
//       </Box>
//       <Button
//         onClick={addTerms}
//         style={{
//           backgroundColor: "rgb(14, 94, 132)",
//           fontWeight: 700,
//           width: "100%",
//           padding: "10px 0px",
//           fontSize: "1.1rem",
//         }}
//         variant="contained"
//       >
//         Submit
//       </Button>
//     </Stack>
//   );
// };

// export default AdminPolicyNotice;


import React, { useState, useRef, useEffect } from "react";
import {
  Typography,
  Box,
  Divider,
  Button,
  Grid,
  TableContainer,
  Table,
  TextField,
  InputLabel,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  Card,
  CardContent
} from "@mui/material";
import { ReactComponent as UploadFileIcon } from "../../../Icons/UploadFileIcon.svg";
import { ReactComponent as ImgIcon } from "../../../Icons/ImgIcon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { ReactComponent as FormIcon } from "../../../Icons/CommonFormIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";
import {toast, ToastContainer} from 'react-toastify'

const languages = [
  { label: 'English', code: 'en' },
  { label: 'Traditional Chinese', code: 'zh-tw' },
  { label: 'Simplified Chinese', code: 'zh' },
];

export default function AdminPolicyNotice() {
    const navigate = useNavigate();
  const dispatch = useDispatch()
  const allLanguages = useSelector((state) => state.language.languageList)
  const [loading, setLoading] = useState(false)

  const { control, handleSubmit, errors, setValue } = useForm({
    defaultValues: {
      en: [{ title: '', description: '' }],
      'zh-tw': [{ title: '', description: '' }],
      zh: [{ title: '', description: '' }],
    },
  });


  const fieldArrays = {
    en: useFieldArray({ control, name: "en" }),
    "zh-tw": useFieldArray({ control, name: "zh-tw" }),
    zh: useFieldArray({ control, name: "zh" }),
  };

    const modules = {
    toolbar: [
      ["bold", "italic", "underline"], // toggled buttons
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"], // superscript/subscript
    ],
  };




  const getTerms = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}getPolicy`
      );
      if (response?.status === 200 && response?.data?.length > 0) {
        const terms = response?.data[0]?.policy[0];
        // Set values for each language
        Object.keys(terms).forEach((langKey) => {
          setValue(langKey, terms[langKey]);
        });
      }
    } catch (error) {
      console.error("Failed to fetch terms:", error);
    }
  };
  

  useEffect(() => {
    getTerms();
  }, []);

    const onSubmit = async (data) => {
    console.log(data);

    setLoading(true)
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}addPolicy`,
        data,
      );
      setLoading(false)
      // navigate("/Admin/NewsList");
      getTerms()
      if(response?.status === 201){
        toast.success("Saved Successfully!")
      }
      console.log(response);
    } catch (error) {
      console.log(error);
      toast.error("Error in creating policy notice!")
      setLoading(false)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };



  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
       <Card sx={{ width: '80%', borderRadius:"6px"}}>
         <CardContent style={{ padding: 0, margin: 0 }}>
         <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              borderRadius:'6px 6px 0px 0px'
              
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography variant="h6_1">Policy Notice</Typography>
          </Box>
    <form onSubmit={handleSubmit(onSubmit)}>
      {languages.map(({ label, code }) => {
        const fieldArray = fieldArrays[code];

        return (
          <div key={code} style={{ marginBottom: '2rem', border: '1px solid #ccc', padding: '1rem' }}>
            <Typography sx={{ml : 2, fontWeight : 700, fontSize : '24px'}}>{label}</Typography>
            {fieldArray.fields.map((item, index) => (
              <div key={item.id} style={{ marginBottom: '1rem' }}>
                <Box style={{ padding: "25px 17px 17px 17px", position : 'relative' }}>
               <InputLabel sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}>{errors?.code[index]?.title ? 'Title*' : 'Title'}</InputLabel>
              <Controller
                name={`${code}.${index}.title`}
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                  <TextField
                    error={Boolean(errors?.code[index]?.title) ? true : false}
                    {...field}
                    placeholder={`Title`}
                    sx={{ 
                        mt: 0, 
                        backgroundColor : 'rgb(249, 250, 251)',
                        borderRadius: 0, 
                        "& .MuiInputBase-input": {
                          color: errors?.code[index]?.title ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.code[index]?.title ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.code[index]?.title ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.code[index]?.title ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                  />
                )}
              />
              {errors?.code[index]?.title ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter title</Typography> : null}
              {index !==0 && (
                <Button
                    type="button"
                    onClick={() => fieldArray.remove(index)}
                    style={{ marginLeft: '0.5rem', color: 'red' }}
                    sx={{position : 'absolute', top : 0, right : 0}}
                  >
                     <ClearIcon />
                  </Button>
              )}
              
              </Box>
                 <Box style={{ padding: "0px 17px 17px" }}>
             <InputLabel sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}>{errors?.code[index]?.description ? 'Description*' : 'Description'}</InputLabel>
              <Controller
                 name={`${code}.${index}.description`}
                rules={{ required: true }} 
                control={control}
                render={({ field }) => (
                  <ReactQuill
                    style={{ height: "180px" }}
                    modules={modules}
                    maxLength={3000}
                    {...field}
                  />
                )}
              />
            </Box>
            <Box style={{ marginTop : '2rem', marginLeft : '1rem'}}>
            {errors?.code[index]?.description ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter description</Typography> : null}
            </Box>
                <Divider sx={{mt : 7, mb : 2}}/>
              </div>
            ))}
            <Button
              variant="contained"
              onClick={() => fieldArray.append({ title: '', description: '' })}
            >
              Add More ({label})
            </Button>
          </div>
        );
      })}
      <Box sx={{display : 'flex', justifyContent : 'flex-end', p : 3}}>
      <Button disabled={loading} variant='contained' type="submit">Submit</Button>
      </Box>
    </form>
    </CardContent>
    </Card>
     </Box>
  );
}


